import { createContext } from 'react';

import { captureException } from '@sentry/browser';

export interface UseUpsertObservationConfigMutationContextInterface {
  captureException: typeof captureException;
}

export const defaultValue: UseUpsertObservationConfigMutationContextInterface =
  {
    captureException,
  };

export const UseUpsertObservationConfigMutationContext =
  createContext<UseUpsertObservationConfigMutationContextInterface>(
    defaultValue
  );
